module.exports = __webpack_public_path__ + "static/assets/befb85b6fd86583558507cf9c880c0a3.svg";